import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
export default function Project({ project }) {
  const { name, slug, images } = project;

  return (
    <article>
      <div>
        <Link className="project-link" to={`/projekty/${slug}`}>
          <div className="project">
            <img alt="" className="project-imgg" src={images[0]} />
            <p className="project-link-name">{name}</p>
          </div>
        </Link>
      </div>
    </article>
  );
}

Project.propTypes = {
  project: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
};



// WEBPACK FOOTER //
// ./src/components/Project.js